module.exports = __webpack_public_path__ + "img/onboard-phone.7d350e5e.png";